/**
 * A reply goes out with the answered message quoted on its first line,
 * "↪ <quote>\n<text>" (send.ts outgoingText): OnlyFans has no replies of its
 * own. The thread draws that line as a quote block above the text.
 */
export interface Quoted {
  /** The quoted line (up to 120 characters of the answered message), or null. */
  quote: string | null;
  /** The message itself, without the quote line. */
  body: string;
}

const QUOTE_LINE = /^↪ ([^\n]*)\n([\s\S]*)$/;

export function splitQuote(text: string): Quoted {
  const [, quote = '', body = ''] = QUOTE_LINE.exec(text) ?? [];
  return body.trim() ? { quote: quote.trim(), body } : { quote: null, body: text };
}

/** The quoted message among `earlier`, newest first: the one whose text begins with the quote. */
export function findQuoted<T extends { text: string }>(quote: string, earlier: T[]): T | null {
  const q = quote.trim();
  if (!q) return null;
  for (let i = earlier.length - 1; i >= 0; i -= 1) {
    const body = splitQuote(earlier[i]!.text).body.trim();
    if (body && (body.startsWith(q) || q.startsWith(body))) return earlier[i]!;
  }
  return null;
}
